import { default as LinkClass } from 'quill/formats/link';

const Protocols = ['http', 'https', 'mailto', 'tel', 'radar', 'rdar', 'smb', 'sms'] as const;

// Nadpisujemy tabelę dozwolonych schematów
(LinkClass as any).PROTOCOL_WHITELIST = Protocols;

// Rozszerzenie klasy Link
export class CustomLinkSanitizer extends (LinkClass as any) {
  static sanitize(url: string): string {
    const sanitized = super.sanitize(url);

    if (!sanitized || sanitized === 'about:blank') {
      return sanitized;
    }

    const hasAllowedProtocol = Protocols.some((proto) => sanitized.startsWith(proto));

    return hasAllowedProtocol ? sanitized : `http://${sanitized}`;
  }
}
